<main>
    <ul>
        <li><h5 class="active">{{ 'header.About Us' | translate }}</h5></li>
        <li><a [routerLink]="['/company-profile']" routerLinkActive="active">{{ "header.Company's Profile" | translate }}</a></li>
        <li><a [routerLink]="['/vision-mission']" routerLinkActive="active">{{ 'header.Vision Mission & Core Value' | translate }}</a></li>
        <li><a [routerLink]="['/company-milestone']" routerLinkActive="active">{{ "header.Company's Milestones" | translate }}</a></li>
        <li><a [routerLink]="['/shareholder']" routerLinkActive="active">{{ 'header.Shareholders' | translate }}</a></li>
        <li><a [routerLink]="['/ceo-message']" routerLinkActive="active">{{ "header.CEO's Message" | translate }}</a></li>
        <li><a [routerLink]="['/management']" routerLinkActive="active">{{ 'header.Management'| translate }}</a></li>
        <li><a [routerLink]="['/organization-chart']" routerLinkActive="active">{{ 'header.Organization Chart' | translate }}</a></li>
        <li><a [routerLink]="['/code-of-conduct']" routerLinkActive="active">{{ 'header.Code of Conduct' | translate }}</a></li>
    </ul>
</main>
